import styled from 'styled-components'

export const StyledWethStatement = styled.div`
  font-size: 12px;
  text-align: center;
  color: #847cae;
  font-weight: 300;
  margin-top: 15px;
  width: 100%;

  a {
    color: #604dbc;
    font-weight: 400;
  }
`
